import { useTenant } from '@/contexts/TenantContext';
import { useCallback } from 'react';

// Global tenant state for non-React usage
let globalTenant: string | null = null;

export function setGlobalTenant(tenant: string | null) {
  globalTenant = tenant;
}

export function getGlobalTenant(): string | null {
  return globalTenant;
}

export function useTenantNavigation() {
  const { tenant } = useTenant();

  const buildTenantPath = useCallback((path: string = ''): string => {
    if (!tenant) {
      return path || '/';
    }
    
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    const tenantPath = `/${encodeURIComponent(tenant)}`;
    
    return cleanPath ? `${tenantPath}/${cleanPath}` : tenantPath;
  }, [tenant]);

  const buildExportUrl = useCallback((baseUrl: string, params: Record<string, string> = {}): string => {
    if (!tenant) {
      return baseUrl;
    }

    const url = new URL(baseUrl, window.location.origin);
    url.searchParams.set('client', tenant);
    
    Object.entries(params).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });

    return url.toString();
  }, [tenant]);

  const getTenantHeaders = useCallback((): Record<string, string> => {
    return tenant ? { 'X-Tenant-Id': tenant } : {};
  }, [tenant]);

  return {
    buildTenantPath,
    buildExportUrl,
    getTenantHeaders,
    tenant,
  };
}

export function extractTenantFromUrl(pathname: string): string | null {
  const regex = /^\/([^/]+)(\/.*)?$/;
  const match = pathname.match(regex);
  
  if (match) {
    const tenantCandidate = match[1];
    
    // Validação básica - mais validação será feita no contexto
    if (tenantCandidate && tenantCandidate !== 'undefined') {
      return tenantCandidate;
    }
  }
  
  return null;
}